
export class RecallType {
    id: number;
    recallTypeName: string;
    status: boolean;
}